import EmailVerificationPage from "./email_verification_page";
import { EmailVerificationManager } from "../../../action_managers/email_verification";

import { connect } from "react-redux";
import { withRouter } from "react-router";
import { withPageTitle } from "../../lib/WithPageTitle";

function mapStateToProps(state) {
  return {
    user: state.user.user,
    isLoading: state.emailVerification.isLoading,
    pushToHome: state.emailVerification.pushToHome,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    verifyEmail: (verificationToken, authToken) => {
      dispatch(
        new EmailVerificationManager({
          verificationToken,
          authToken,
        }).run()
      );
    },
  };
}

const EmailVerificationPageWrapper = withRouter(
  connect(mapStateToProps, mapDispatchToProps)(EmailVerificationPage)
);

export default withPageTitle(EmailVerificationPageWrapper, "Email Verification");
